import employerTranslations from './employerValidations.lang.json';
import investmentAccountTranslations from './investmentAccountValidations.lang.json';
import transferRequestTranslations from './transferValidations.lang.json';
import userTranslations from './userValidations.lang.json';

const allTranslations = {
  ...employerTranslations,
  ...investmentAccountTranslations,
  ...transferRequestTranslations,
  ...userTranslations,
};

export default allTranslations;

//NOTE: see comment in corresponding .node.lang.js
